<template>
  <div class="NoticeListBox">
    <ul class="noticeList" :style="{top:top+'px',transition:`top ${animateTime}s`}">
      <li v-for="(item,index) in notices" :key="index" >
        <a href="javascript:void(0)">{{item}}</a>
      </li>
      <li v-if="notices.length > 0">
        <a href="javascript:void(0)">{{notices[0]}}</a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'NoticeList',
  props:{
    notices:{
      type:Array,
      default:() => []
    }
  },
  data(){
    return{
      top:0,
      height:40,
      animateTime:1,
      timer: null
    }
  },
  mounted(){
    this.timer = setInterval(this.topAnimate, 3500);
  },
  beforeDestroy(){
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods:{
    topAnimate(){
      if (this.notices.length <= 1) return;
      if(this.top <= (-this.notices.length * this.height)){
        this.top = 0;
        this.animateTime = 0;
        return;
      }
      this.animateTime = 1;
      this.top -= this.height;
    }
  }
}
</script>

<style scoped lang="less">
@import "../assets/css/var.less";

.NoticeListBox{
  height: 40px;
  overflow: hidden;
  position: relative;
  display: inline-block;
  width: 240px;

  .noticeList{
    width: 100%;
    position: absolute;
    left: 0;
    list-style: none;
    padding: 0;
    margin: 0;

    li{
      width: 100%;
      height: 40px;
      line-height: 40px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;

      a{
        color: @brandPrimary;
        text-decoration: none;
        font-size: 13px;
        font-weight: 500;
        transition: all 0.2s ease;

        &:hover{
          color: @brandSecondary;
          text-decoration: underline;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/NoticeList.vue